(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-grid-item"] && !Shopify.designMode) return;
  try {
    (function () {
      if (window.__plpGalleryBound) return;
      window.__plpGalleryBound = true;

      function getState(host) {
        if (!host._plpGallery) {
          host._plpGallery = {
            active: false,
            built: false,
            transitioning: false,
            index: 0,
            imageZoneHovering: false,
            slideCount: parseInt(host.getAttribute('data-slide-count'), 10) || 1,
            hasClones: false
          };
        }
        return host._plpGallery;
      }

      function getCard(host) {
        return host.closest('.grid-product');
      }

      function getIndicator(host) {
        return host.querySelector('.plp-gallery-indicator');
      }

      function syncTrackLayoutState(host) {
        var state = getState(host);
        var metaItems = host.querySelectorAll('.plp-gallery-image-data');

        if (metaItems.length) {
          state.slideCount = metaItems.length;
        }

        var track = getTrack(host);
        if (track) {
          state.hasClones = !!track.querySelector('.plp-gallery-slide--clone');
        }

        state.index = Number(state.index) || 0;

        if (state.slideCount > 0 && state.index > state.slideCount - 1) {
          state.index = state.slideCount - 1;
        }
      }

      function ensureCloneSlides(host) {
        var state = getState(host);
        var track = getTrack(host);
        if (!track || state.slideCount <= 1) {
          state.hasClones = false;
          return;
        }

        var realSlides = track.querySelectorAll(
          '.plp-gallery-slide:not(.plp-gallery-slide--clone)'
        );
        if (realSlides.length <= 1) {
          state.hasClones = false;
          return;
        }

        if (!track.querySelector('[data-clone="last"]')) {
          cloneSlide(track, realSlides[realSlides.length - 1], 'last', true);
        }

        if (!track.querySelector('[data-clone="first"]')) {
          cloneSlide(track, realSlides[0], 'first', false);
        }

        state.hasClones = true;

        track.querySelectorAll('.plp-gallery-slide--clone').forEach(function (clone) {
          loadSlideImage(clone);
        });
      }

      function prepareGallery(host) {
        syncTrackLayoutState(host);
        ensureCloneSlides(host);
      }

      function setIndicatorIndex(host, index) {
        var indicator = getIndicator(host);
        if (!indicator) return;
        var state = getState(host);
        var clamped = Math.max(0, Math.min(index, state.slideCount - 1));
        indicator.style.setProperty('--plp-active-index', clamped);
        host.classList.remove(
          'is-plp-indicator-wrap-next',
          'is-plp-indicator-wrap-prev',
          'is-plp-indicator-wrap-run'
        );
      }

      function runIndicatorWrap(host, direction, fromIndex) {
        var indicator = getIndicator(host);
        if (indicator) {
          indicator.style.setProperty('--plp-active-index', fromIndex);
        }

        var wrapClass =
          direction > 0 ? 'is-plp-indicator-wrap-next' : 'is-plp-indicator-wrap-prev';

        host.classList.remove(
          'is-plp-indicator-wrap-next',
          'is-plp-indicator-wrap-prev',
          'is-plp-indicator-wrap-run'
        );
        host.classList.add(wrapClass);

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            host.classList.add('is-plp-indicator-wrap-run');
          });
        });
      }

      function getTrackIndexForLogical(host, logicalIndex) {
        var state = getState(host);
        if (!state.hasClones || state.slideCount <= 1) return logicalIndex;
        return logicalIndex + 1;
      }

      function cloneSlide(track, sourceSlide, cloneType, prepend) {
        var clone = sourceSlide.cloneNode(true);
        clone.classList.add('plp-gallery-slide--clone');
        clone.setAttribute('data-clone', cloneType);
        clone.removeAttribute('data-index');
        if (prepend) {
          track.insertBefore(clone, track.firstChild);
        } else {
          track.appendChild(clone);
        }
        return clone;
      }

      function loadSlideImage(slide) {
        if (slide.dataset.loaded === 'true') return;
        var src = slide.getAttribute('data-src');
        var alt = slide.getAttribute('data-alt') || '';
        if (!src) return;
        var img = document.createElement('img');
        img.src = src;
        img.alt = alt;
        img.loading = 'lazy';
        img.decoding = 'async';
        slide.appendChild(img);
        slide.dataset.loaded = 'true';
      }

      function buildTrack(host) {
        var state = getState(host);
        syncTrackLayoutState(host);

        if (state.built) {
          ensureCloneSlides(host);
          layoutGallerySlides(host);
          return;
        }

        var track = host.querySelector('.plp-gallery-track');
        var metaItems = host.querySelectorAll('.plp-gallery-image-data');
        if (!track || !metaItems.length) return;

        metaItems.forEach(function (item) {
          var slide = document.createElement('div');
          slide.className = 'plp-gallery-slide';
          slide.setAttribute('data-index', item.getAttribute('data-index'));
          slide.setAttribute('data-src', item.getAttribute('data-src'));
          slide.setAttribute('data-alt', item.getAttribute('data-alt') || '');

          if (item.getAttribute('data-lazy') !== 'true') {
            loadSlideImage(slide);
          }

          track.appendChild(slide);
        });

        ensureCloneSlides(host);
        state.built = true;
        layoutGallerySlides(host);
      }

      function layoutGallerySlides(host) {
        var viewport = host.querySelector('.plp-gallery-viewport');
        var slides = host.querySelectorAll('.plp-gallery-slide');
        if (!viewport || !slides.length) return;

        var width = viewport.clientWidth;
        if (!width) return;

        slides.forEach(function (slide) {
          slide.style.flex = '0 0 ' + width + 'px';
          slide.style.width = width + 'px';
        });
      }

      function getTrack(host) {
        return host.querySelector('.plp-gallery-track');
      }

      function applyTrackTransform(host, trackIndex, offsetPx, instant) {
        var viewport = host.querySelector('.plp-gallery-viewport');
        var track = getTrack(host);
        if (!viewport || !track) return;

        layoutGallerySlides(host);

        var width = viewport.clientWidth || 0;
        if (!width) return;

        var x = -(trackIndex * width) + (offsetPx || 0);
        track.style.transition = instant ? 'none' : 'transform 0.32s ease';
        track.style.transform = 'translate3d(' + x + 'px,0,0)';
      }

      function setTrackTransform(host, logicalIndex, offsetPx, instant) {
        applyTrackTransform(
          host,
          getTrackIndexForLogical(host, logicalIndex),
          offsetPx,
          instant
        );
      }

      function setTrackTransformByTrackIndex(host, trackIndex, offsetPx, instant) {
        applyTrackTransform(host, trackIndex, offsetPx, instant);
      }

      function snapTrackTransform(host, logicalIndex, offsetPx) {
        var track = getTrack(host);
        if (track) {
          track.style.transition = 'none';
        }
        setTrackTransform(host, logicalIndex, offsetPx || 0, true);
        if (track) {
          void track.offsetHeight;
          track.style.transition = '';
        }
      }

      function getWrapCloneSlide(host, direction) {
        var track = getTrack(host);
        if (!track) return null;
        return direction > 0
          ? track.querySelector('[data-clone="first"]')
          : track.querySelector('[data-clone="last"]');
      }

      function runWrapTrackAnimation(host, fromIndex, toIndex, wrapTrackIndex, direction, dragOffsetPx) {
        var state = getState(host);

        state.transitioning = true;

        if (Math.abs(dragOffsetPx || 0) < 1) {
          setTrackTransform(host, fromIndex, 0, true);
        }

        runIndicatorWrap(host, direction, fromIndex);

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            setTrackTransformByTrackIndex(host, wrapTrackIndex, 0, false);
          });
        });

        finishTrackTransition(host, function () {
          state.index = toIndex;
          preloadAdjacentSlides(host, toIndex);
          snapTrackTransform(host, toIndex, 0);
          host.classList.add('is-plp-indicator-snap');
          setIndicatorIndex(host, toIndex);
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              host.classList.remove('is-plp-indicator-snap');
            });
          });

          if (isMobilePlpGallery()) {
            host.classList.remove('is-plp-gallery-swipe-active');
            host.classList.remove('is-plp-gallery-dragging');
            var viewport = host.querySelector('.plp-gallery-viewport');
            if (viewport) viewport.classList.remove('is-plp-gallery-dragging');
          }

          state.transitioning = false;
        });
      }

      function getDragStartIndex(host) {
        var state = getState(host);
        if (state.active) return state.index;

        var indicator = getIndicator(host);
        if (indicator) {
          var idx = parseInt(
            indicator.style.getPropertyValue('--plp-active-index') || '0',
            10
          );
          if (!isNaN(idx)) return idx;
        }

        return state.imageZoneHovering ? 1 : 0;
      }

      function activateGallery(host, startIndex, callback) {
        var state = getState(host);
        buildTrack(host);

        var viewport = host.querySelector('.plp-gallery-viewport');
        var slides = host.querySelectorAll(
          '.plp-gallery-slide:not(.plp-gallery-slide--clone)'
        );
        if (!viewport || !slides.length) {
          if (callback) callback();
          return;
        }

        var clamped = Math.max(
          0,
          Math.min(
            typeof startIndex === 'number' ? startIndex : state.index,
            state.slideCount - 1
          )
        );

        var keepSlideReady =
          host.classList.contains('is-plp-gallery-slide-ready') &&
          state.active &&
          state.index === clamped;

        host.classList.add('is-plp-gallery-active');
        if (!keepSlideReady) {
          host.classList.remove('is-plp-gallery-slide-ready');
        }

        state.active = true;
        state.index = clamped;
        viewport.setAttribute('aria-hidden', 'false');

        preloadAdjacentSlides(host, clamped);
        setTrackTransform(host, clamped, 0, true);
        setIndicatorIndex(host, clamped);

        if (isSlideImageReady(slides[clamped])) {
          host.classList.add('is-plp-gallery-slide-ready');
          if (callback) callback();
          return;
        }

        waitForSlideImage(slides[clamped], function () {
          host.classList.add('is-plp-gallery-slide-ready');
          if (callback) callback();
        });
      }

      function refreshGalleryLayout(host) {
        prepareGallery(host);
        layoutGallerySlides(host);
        setTrackTransform(host, getState(host).index, 0, true);
      }

      function getWrappedIndex(current, direction, slideCount) {
        var count = Number(slideCount) || 1;
        var index = Number(current) || 0;
        var delta = direction > 0 ? 1 : -1;
        return (index + delta + count) % count;
      }

      function isWrapStep(fromIndex, direction, slideCount) {
        var count = Number(slideCount) || 1;
        if (count <= 1) return false;

        var from = Number(fromIndex) || 0;
        return direction > 0 ? from >= count - 1 : from <= 0;
      }

      function finishTrackTransition(host, callback) {
        var track = getTrack(host);
        if (!track) {
          callback();
          return;
        }

        var done = false;
        function onEnd(e) {
          if (done) return;
          if (e && (e.target !== track || e.propertyName !== 'transform')) return;
          done = true;
          track.removeEventListener('transitionend', onEnd);
          callback();
        }

        track.addEventListener('transitionend', onEnd);
        window.setTimeout(function () {
          onEnd(null);
        }, PLP_STEP_DURATION + 80);
      }

      function goToIndexWrap(host, fromIndex, toIndex, direction, dragOffsetPx) {
        prepareGallery(host);

        fromIndex = Number(fromIndex) || 0;
        toIndex = Number(toIndex) || 0;
        dragOffsetPx = dragOffsetPx || 0;

        var state = getState(host);
        var slides = host.querySelectorAll(
          '.plp-gallery-slide:not(.plp-gallery-slide--clone)'
        );
        var target = slides[toIndex];

        state.transitioning = false;

        if (!target) return;

        if (!isSlideImageReady(target)) {
          if (Math.abs(dragOffsetPx) < 1) {
            setTrackTransform(host, fromIndex, 0, true);
          }
          loadSlideImage(target);
          waitForSlideImage(target, function () {
            goToIndexWrap(host, fromIndex, toIndex, direction, dragOffsetPx);
          });
          return;
        }

        var wrapTrackIndex = direction > 0 ? slides.length + 1 : 0;
        var cloneSlide = getWrapCloneSlide(host, direction);

        function startWrap() {
          runWrapTrackAnimation(
            host,
            fromIndex,
            toIndex,
            wrapTrackIndex,
            direction,
            dragOffsetPx
          );
        }

        if (isMobilePlpGallery() && cloneSlide) {
          waitForSlideImage(cloneSlide, startWrap);
          return;
        }

        startWrap();
      }

      function goToIndex(host, index, instant, force) {
        prepareGallery(host);
        var state = getState(host);

        var viewport = host.querySelector('.plp-gallery-viewport');
        var slides = host.querySelectorAll(
          '.plp-gallery-slide:not(.plp-gallery-slide--clone)'
        );
        if (!viewport || !slides.length) return;

        var clamped = Math.max(
          0,
          Math.min(Number(index) || 0, state.slideCount - 1)
        );
        var target = slides[clamped];

        if (force) {
          state.transitioning = false;
        }

        if (!instant && state.transitioning && !force) return;

        if (!instant && !isSlideImageReady(target)) {
          setTrackTransform(host, state.index, 0, true);
          loadSlideImage(target);
          waitForSlideImage(target, function () {
            goToIndex(host, index, instant, force);
          });
          return;
        }

        state.index = clamped;
        preloadAdjacentSlides(host, clamped);

        setTrackTransform(host, clamped, 0, instant);
        setIndicatorIndex(host, clamped);

        if (!instant) {
          state.transitioning = true;
          window.setTimeout(function () {
            state.transitioning = false;
          }, PLP_STEP_DURATION);
        }
      }

      function stepGallery(host, direction, instant, force, dragOffsetPx) {
        prepareGallery(host);
        var state = getState(host);

        if (state.slideCount <= 1) return;

        direction = direction > 0 ? 1 : -1;
        dragOffsetPx = dragOffsetPx || 0;

        var fromIndex = state.index;
        var toIndex = getWrappedIndex(fromIndex, direction, state.slideCount);

        if (isWrapStep(fromIndex, direction, state.slideCount)) {
          if (instant) {
            goToIndex(host, toIndex, true, force);
            return;
          }

          goToIndexWrap(host, fromIndex, toIndex, direction, dragOffsetPx);
          return;
        }

        if (state.transitioning && !instant && !force) return;

        if (Math.abs(dragOffsetPx) >= 1 && !instant) {
          setTrackTransform(host, fromIndex, dragOffsetPx, true);
          requestAnimationFrame(function () {
            goToIndex(host, toIndex, false, force);
          });
          return;
        }

        goToIndex(host, toIndex, instant, force);
      }

      function deactivateGallery(host) {
        var state = getState(host);
        host.classList.remove('is-plp-gallery-active');
        host.classList.remove('is-plp-gallery-slide-ready');
        host.classList.remove('is-plp-gallery-swipe-active');
        host.classList.remove('is-plp-gallery-dragging');
        state.active = false;
        state.transitioning = false;
        state.index = 0;
        state.imageZoneHovering = false;

        var viewport = host.querySelector('.plp-gallery-viewport');
        var track = getTrack(host);
        if (viewport) {
          viewport.setAttribute('aria-hidden', 'true');
          viewport.classList.remove('is-plp-gallery-dragging');
        }
        if (track) {
          track.style.transform = '';
          track.style.transition = '';
        }

        setIndicatorIndex(host, 0);
      }

      function isPointInRect(rect, x, y) {
        return (
          x >= rect.left &&
          x <= rect.right &&
          y >= rect.top &&
          y <= rect.bottom
        );
      }

      function isPointInZone(zone, x, y) {
        return isPointInRect(zone.getBoundingClientRect(), x, y);
      }

      function isPointInCard(card, x, y) {
        return isPointInRect(card.getBoundingClientRect(), x, y);
      }

      var plpGalleryImageHoverHost = null;
      var plpGalleryCardHoverHost = null;
      var plpTouch = null;

      var PLP_TOUCH_THRESHOLD = 24;
      var PLP_TOUCH_INTENT = 10;
      var PLP_STEP_DURATION = 320;
      var PLP_IMAGE_WAIT_MS = 500;
      var PLP_SWIPE_VELOCITY = 0.4;

      function isMobilePlpGallery() {
        return window.matchMedia('(max-width: 768px)').matches;
      }

      function findTouchById(list, id) {
        for (var i = 0; i < list.length; i++) {
          if (list[i].identifier === id) return list[i];
        }
        return null;
      }

      function preloadGalleryOnHover(host) {
        buildTrack(host);

        var slides = host.querySelectorAll(
          '.plp-gallery-slide:not(.plp-gallery-slide--clone)'
        );
        for (var i = 0; i < Math.min(slides.length, 4); i++) {
          loadSlideImage(slides[i]);
        }
      }

      function waitForSlideImage(slide, callback) {
        if (!slide) {
          callback();
          return;
        }

        loadSlideImage(slide);

        var img = slide.querySelector('img');
        if (!img) {
          callback();
          return;
        }

        if (img.complete && img.naturalWidth > 0) {
          callback();
          return;
        }

        var finished = false;
        function done() {
          if (finished) return;
          finished = true;
          callback();
        }

        img.onload = done;
        img.onerror = done;
        window.setTimeout(done, PLP_IMAGE_WAIT_MS);
      }

      function isSlideImageReady(slide) {
        if (!slide || slide.getAttribute('data-loaded') !== 'true') return false;
        var img = slide.querySelector('img');
        return !!(img && img.complete && img.naturalWidth > 0);
      }

      function preloadAdjacentSlides(host, index) {
        var slides = host.querySelectorAll(
          '.plp-gallery-slide:not(.plp-gallery-slide--clone)'
        );
        var count = slides.length;
        if (count <= 1) return;

        loadSlideImage(slides[(index + 1) % count]);
        loadSlideImage(slides[(index + 2) % count]);
        loadSlideImage(slides[(index - 1 + count) % count]);
      }

      function isPointerInGalleryZone(host, x, y) {
        var zone = host.querySelector('.plp-gallery-image-zone');
        if (zone && isPointInZone(zone, x, y)) return true;

        var mask = host.querySelector('.grid-product__image-mask');
        return !!(mask && isPointInRect(mask.getBoundingClientRect(), x, y));
      }

      function shouldIgnoreGalleryInteraction(target) {
        return !!target.closest(
          '.plp-gallery-arrow, .quick-product__btn, .swym-button, .color-swatch'
        );
      }

      function getGalleryHostFromTouch(touch) {
        var el = document.elementFromPoint(touch.clientX, touch.clientY);
        if (!el) return null;
        if (shouldIgnoreGalleryInteraction(el)) return null;
        var host = el.closest('[data-plp-gallery]');
        if (!host || !isPointerInGalleryZone(host, touch.clientX, touch.clientY)) return null;
        return host;
      }

      function getIndicatorIndexValue(host) {
        var indicator = getIndicator(host);
        if (!indicator) return 0;
        var idx = parseInt(
          indicator.style.getPropertyValue('--plp-active-index') || '0',
          10
        );
        return isNaN(idx) ? 0 : idx;
      }

      function revertMobileHoverForGallery(host) {
        host.classList.remove('is-plp-gallery-hovering');
        host.classList.remove('active');

        var state = getState(host);
        state.imageZoneHovering = false;
        setIndicatorIndex(host, 0);

        if (plpGalleryImageHoverHost === host) {
          plpGalleryImageHoverHost = null;
        }
      }

      function getInstantSwipeStartIndex(host) {
        var state = getState(host);
        if (state.imageZoneHovering || getIndicatorIndexValue(host) > 0) {
          return getDragStartIndex(host);
        }
        return 0;
      }

      function isPointInProductMeta(host, x, y) {
        var link = host.querySelector('.grid-product__link');
        return !!(link && isPointInRect(link.getBoundingClientRect(), x, y));
      }

      function syncProductMetaIndicator(host) {
        var state = getState(host);
        if (state.active) {
          setIndicatorIndex(host, state.index);
          return;
        }

        if (plpTouch || state.slideCount <= 1) return;

        state.imageZoneHovering = true;
        setIndicatorIndex(host, 1);
        preloadGalleryOnHover(host);

        if (isMobilePlpGallery()) {
          host.classList.add('active');
        }
      }

      function onImageZoneEnter(host) {
        host.classList.add('is-plp-gallery-hovering');

        var state = getState(host);
        state.imageZoneHovering = true;

        if (state.active) {
          setIndicatorIndex(host, state.index);
          return;
        }

        if (plpTouch) return;

        if (state.slideCount > 1) {
          setIndicatorIndex(host, 1);
          preloadGalleryOnHover(host);
          if (isMobilePlpGallery()) {
            host.classList.add('active');
          }
        }
      }

      function onImageZoneLeave(host) {
        host.classList.remove('is-plp-gallery-hovering');
        getState(host).imageZoneHovering = false;
      }

      function onCardLeave(host) {
        if (plpTouch) return;
        deactivateGallery(host);
      }

      function updatePlpGalleryHover(clientX, clientY) {
        if (plpTouch) return;

        var nextImageHost = null;
        var nextCardHost = null;

        document.querySelectorAll('[data-plp-gallery]').forEach(function (host) {
          var zone = host.querySelector('.plp-gallery-image-zone');
          var card = getCard(host);
          var inImageZone = zone && isPointInZone(zone, clientX, clientY);
          var inProductMeta = !inImageZone && isPointInProductMeta(host, clientX, clientY);

          if (inImageZone) {
            nextImageHost = host;
          } else if (inProductMeta) {
            syncProductMetaIndicator(host);
          }

          if (card && isPointInCard(card, clientX, clientY)) {
            nextCardHost = host;
          }
        });

        if (nextImageHost !== plpGalleryImageHoverHost) {
          if (plpGalleryImageHoverHost) {
            onImageZoneLeave(plpGalleryImageHoverHost);
          }
          if (nextImageHost) {
            onImageZoneEnter(nextImageHost);
          }
          plpGalleryImageHoverHost = nextImageHost;
        }

        if (nextCardHost !== plpGalleryCardHoverHost) {
          if (plpGalleryCardHoverHost) {
            onCardLeave(plpGalleryCardHoverHost);
          }
          plpGalleryCardHoverHost = nextCardHost;
        }
      }

      document.addEventListener(
        'mousemove',
        function (e) {
          updatePlpGalleryHover(e.clientX, e.clientY);
        },
        { passive: true }
      );

      document.documentElement.addEventListener('mouseleave', function () {
        if (plpGalleryImageHoverHost) {
          onImageZoneLeave(plpGalleryImageHoverHost);
          plpGalleryImageHoverHost = null;
        }
        if (plpGalleryCardHoverHost) {
          onCardLeave(plpGalleryCardHoverHost);
          plpGalleryCardHoverHost = null;
        }
      });

      document.addEventListener('click', function (e) {
        var prev = e.target.closest('.plp-gallery-arrow--prev');
        var next = e.target.closest('.plp-gallery-arrow--next');
        var btn = prev || next;
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        var host = btn.closest('[data-plp-gallery]');
        if (!host) return;

        var state = getState(host);
        var startIndex = state.imageZoneHovering ? 1 : state.index;
        var delta = next ? 1 : -1;

        if (!state.active) {
          activateGallery(host, startIndex, function () {
            stepGallery(host, delta, false);
          });
          return;
        }

        stepGallery(host, delta, false);
      });

      function clearPlpSwipeClasses(host) {
        if (!host) return;
        host.classList.remove('is-plp-gallery-dragging');
        host.classList.remove('is-plp-gallery-swipe-active');
        var viewport = host.querySelector('.plp-gallery-viewport');
        if (viewport) viewport.classList.remove('is-plp-gallery-dragging');
      }

      function beginMobileGalleryDrag(host) {
        var state = getState(host);
        host.classList.add('is-plp-gallery-swipe-active');
        host.classList.add('is-plp-gallery-dragging');

        var viewport = host.querySelector('.plp-gallery-viewport');
        if (viewport) viewport.classList.add('is-plp-gallery-dragging');

        if (!state.active) {
          var startIndex = getInstantSwipeStartIndex(host);
          plpTouch.instantSwipe = startIndex === 0;

          if (plpTouch.instantSwipe) {
            revertMobileHoverForGallery(host);
          }

          activateGallery(host, startIndex);
          plpTouch.activatedThisGesture = true;
        }
      }

      function finishMobileTouch(touch) {
        if (!plpTouch || touch.identifier !== plpTouch.identifier) return;

        var host = plpTouch.host;
        var state = getState(host);
        var dx = touch.clientX - plpTouch.startX;
        var dy = touch.clientY - plpTouch.startY;
        var elapsed = Math.max(Date.now() - plpTouch.startTime, 1);
        var velocity = dx / elapsed;
        var direction = 0;
        var viewport = host.querySelector('.plp-gallery-viewport');
        var width = viewport ? viewport.clientWidth || 0 : 0;
        var dragOffset = 0;
        var willWrap = false;

        if (plpTouch.horizontal) {
          dragOffset = Math.max(-width, Math.min(width, dx));

          if (
            Math.abs(dx) >= PLP_TOUCH_THRESHOLD ||
            Math.abs(velocity) >= PLP_SWIPE_VELOCITY
          ) {
            if (Math.abs(dx) > Math.abs(dy)) {
              direction = dx < 0 ? 1 : -1;
            }
          }
        }

        if (direction !== 0) {
          willWrap = isWrapStep(state.index, direction, state.slideCount);
        }

        if (willWrap) {
          host.classList.remove('is-plp-gallery-dragging');
          if (viewport) viewport.classList.remove('is-plp-gallery-dragging');
        } else {
          clearPlpSwipeClasses(host);
        }

        var hoverDelay = 0;

        if (direction !== 0) {
          if (!state.active) {
            var startIndex = plpTouch.instantSwipe ? 0 : getDragStartIndex(host);
            if (plpTouch.instantSwipe) {
              revertMobileHoverForGallery(host);
            }
            activateGallery(host, startIndex);
          }
          stepGallery(host, direction, false, true, dragOffset);
          hoverDelay = PLP_STEP_DURATION + 80;
        } else if (plpTouch.horizontal) {
          if (plpTouch.activatedThisGesture && !plpTouch.wasActiveBefore) {
            deactivateGallery(host);
            setIndicatorIndex(host, plpTouch.instantSwipe ? 0 : 1);
          } else if (state.active) {
            goToIndex(host, state.index, true);
            setIndicatorIndex(host, state.index);
          }
        }

        var endX = touch.clientX;
        var endY = touch.clientY;
        plpTouch = null;

        window.setTimeout(function () {
          updatePlpGalleryHover(endX, endY);
        }, hoverDelay);
      }

      document.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches[0]) return;

          var touch = e.touches[0];

          if (isMobilePlpGallery() && !plpTouch) {
            var host = getGalleryHostFromTouch(touch);
            if (host) {
              buildTrack(host);
              var state = getState(host);
              host.classList.remove('active');
              plpTouch = {
                host: host,
                identifier: touch.identifier,
                startX: touch.clientX,
                startY: touch.clientY,
                startTime: Date.now(),
                horizontal: false,
                wasActiveBefore: state.active,
                activatedThisGesture: false,
                instantSwipe: false
              };
              return;
            }
          }

          updatePlpGalleryHover(touch.clientX, touch.clientY);
        },
        { passive: true }
      );

      document.addEventListener(
        'touchmove',
        function (e) {
          if (isMobilePlpGallery() && plpTouch) {
            var touch = findTouchById(e.touches, plpTouch.identifier);
            if (touch) {
              var host = plpTouch.host;
              var dx = touch.clientX - plpTouch.startX;
              var dy = touch.clientY - plpTouch.startY;

              if (!plpTouch.horizontal) {
                if (Math.abs(dx) < PLP_TOUCH_INTENT && Math.abs(dy) < PLP_TOUCH_INTENT) return;

                if (Math.abs(dy) >= Math.abs(dx)) {
                  plpTouch = null;
                  return;
                }

                plpTouch.horizontal = true;
                beginMobileGalleryDrag(host);
              }

              e.preventDefault();

              var state = getState(host);
              var width = host.querySelector('.plp-gallery-viewport').clientWidth || 0;
              var clampedDx = Math.max(-width, Math.min(width, dx));
              setTrackTransform(host, state.index, clampedDx, true);
              return;
            }
          }

          if (plpTouch) return;
          if (e.touches[0]) {
            updatePlpGalleryHover(e.touches[0].clientX, e.touches[0].clientY);
          }
        },
        { passive: false }
      );

      document.addEventListener(
        'touchend',
        function (e) {
          if (isMobilePlpGallery() && plpTouch) {
            var touch = findTouchById(e.changedTouches, plpTouch.identifier);
            if (touch) {
              finishMobileTouch(touch);
              return;
            }
          }

          if (plpTouch) return;
          if (e.changedTouches[0]) {
            updatePlpGalleryHover(
              e.changedTouches[0].clientX,
              e.changedTouches[0].clientY
            );
          }
        },
        { passive: true }
      );

      document.addEventListener(
        'touchcancel',
        function (e) {
          if (!isMobilePlpGallery() || !plpTouch) return;

          var touch = findTouchById(e.changedTouches, plpTouch.identifier);
          if (!touch) return;

          var host = plpTouch.host;
          clearPlpSwipeClasses(host);

          if (plpTouch.activatedThisGesture && !plpTouch.wasActiveBefore) {
            deactivateGallery(host);
            setIndicatorIndex(host, plpTouch.instantSwipe ? 0 : 1);
          } else if (getState(host).active) {
            goToIndex(host, getState(host).index, true);
          }

          var endX = touch.clientX;
          var endY = touch.clientY;
          plpTouch = null;

          window.setTimeout(function () {
            updatePlpGalleryHover(endX, endY);
          }, 0);
        },
        { passive: true }
      );

      window.addEventListener('resize', function () {
        document.querySelectorAll('[data-plp-gallery].is-plp-gallery-active').forEach(function (host) {
          refreshGalleryLayout(host);
        });
      });
    })();
  } catch(e) { console.error(e); }
})();

})();
